// Maps a normalized weather reading to a single display emoji. Bucket
// boundaries mirror WeatherSummary.jsx's video-selection thresholds so the
// icon on a map pin and the mood video on the dashboard agree with each
// other for the same reading.
export function getWeatherIcon(weather, isDayTime = true) {
  const cloudCover = weather?.cloudCover ?? 0;
  const rainChance = weather?.rainChance ?? 0;

  if (rainChance > 80) return '⛈️';
  if (rainChance > 60) return isDayTime ? '🌦️' : '🌧️';
  if (cloudCover >= 60) return '☁️';
  if (cloudCover >= 20) return isDayTime ? '⛅' : '🌥️';
  return isDayTime ? '☀️' : '🌙';
}
